export const SIMULATION_FAILED_TITLE = "This simulation couldn't finish";
export const SIMULATION_FAILED_TEAM_ALERTED = 'Our team has been alerted and is looking into it.';
